import React from 'react';
import * as Sentry from '@sentry/react';
import { SvgIconProps } from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import ProgynyCrown from './colored/ProgynyCrown';
import CarrumCircle from './colored/CarrumCircle';

const iconMap: Record<string, React.ComponentType<SvgIconProps>> = {
  ProgynyCrown: ProgynyCrown,
  CarrumCircle: CarrumCircle,
};

interface IconMapProps extends SvgIconProps {
  iconName: string;
}

export default function IconMap({ iconName, color = 'primary', ...rest }: IconMapProps) {
  const IconComponent = iconMap[iconName];
  if (!IconComponent) {
    Sentry.captureMessage(`Unknown icon name in iconMap: ${iconName}`, (scope) =>
      scope.setLevel('warning')
    );
    // fallback to dot icon if iconName is not found in iconMap
    return <FiberManualRecordIcon color={color} {...rest} />;
  }
  return <IconComponent color={color} {...rest} />;
}
